import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import IconButton from "../../components/button/IconButton";
import {Badge, Form, Modal, Row} from "react-bootstrap";
import renderUtils from "../../helpers/renderUtils";
import OperatingParametersComponent from "../operatingParameter/OperatingParametersComponent";
import {Actions} from "../../../client/Actions";
import fields from "../operatingParameter/group/OperationParametrFromGroupFormConfig";


const MachineParameterTypes = ({machine, setLoader, readOnly}) => {

    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    const [operatingParameters, setOperatingParameters] = useState([])


    function loadData() {
        Actions.get("production/operatingParameters/" + machine.id, setOperatingParameters)
    }


    useEffect(loadData, [])


    return <>


        <IconButton
            tooltip={t("object_types.operating_parameter_template")}
            size={"sm"}
            variant={"outline-primary"}
            className={"mr-2 border-none btn-circle"}
            icon={"fa-gear"}
            text={<span className={"ml-1"}>{operatingParameters?.length}</span>}
            onClick={() => setOpen(true)}
        />

        <Modal show={open} size={"xl"} onHide={() => setOpen(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className={"fas fa-gear text-primary mr-1"}></i>
                    <span className={"text-primary mr-2"}>{operatingParameters?.length}</span>
                    <Badge variant={"primary"} className={"mr-2"}>
                        {renderUtils.renderMachineType(machine, t)}
                    </Badge>
                    <Badge variant={"secondary"} className={"mr-2 font-max"}>
                        {renderUtils.renderMachine(machine)}
                    </Badge>


                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <OperatingParametersComponent
                        setLoader={setLoader}
                        addAsList={true}
                        addFromGroup={true}
                        pagination={true}
                        addFromGroupFields={fields(t)}
                        editable={true}
                        editWithId={true}
                        fromModal={true}
                        readOnly={readOnly}
                        api={"production/operatingParameters/" + machine.id}
                        deleteApi={"production/operatingParameters"}
                        editApi={"production/operatingParameters"}
                        onParametersUpdate={setOperatingParameters}
                    />
                </Row>
            </Modal.Body>
        </Modal>

    </>;
}

export default MachineParameterTypes;

